import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const Activate = observer(class Activate extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const _this = this;

    const data = {
      active: this.active.checked,
      forceSetupVerification: false
    }

    const callback = () => {
      _this.props.routing.history.push('/');
    }

    this.props.store.RegisterStore.updateProctor(data, callback);
  }

  render() {
    const { translation } = this.props;
    const { SessionStore, SettingsStore } = this.props.store;
    const { userSettings } = SettingsStore;

    if(!SessionStore.loading) {
      return(
        <form
          className="panel"
          onSubmit={(e) => this.props.checkValidity(e, this.handleSubmit)}
          noValidate
        >
          <div className="panel__header">
            <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
          </div>

          <div className="panel__body">
            {userSettings.active &&
              <p className="note note--prominent">
                <strong>{translation.body_active}</strong> {translation.body}
              </p>
            }

            {!userSettings.active &&
              <p className="note note--prominent">
                <strong>{translation.body_inactive}</strong> {translation.body}
              </p>
            }

            <fieldset>
              <ul className="fields">
                <li>
                  <input
                    type="checkbox"
                    id="activate"
                    className="switch-input"
                    ref={(input) => this.active = input}
                    value={true}
                    defaultChecked={userSettings.active}
                  />

                  <label
                    className="switch-label"
                    htmlFor="activate"
                  >
                    <span className="meta">{translation.activate}</span>
                  </label>

                  <label
                    className="switch-label--alt"
                    htmlFor="activate"
                  >
                    {translation.activate}
                  </label>
                </li>
              </ul>
            </fieldset>

            <div className="panel__actions actions">
              <button
                className="actions__btn actions__btn--secondary"
                onClick={this.props.prevStep}
                type="button"
              >
                {translation.back}
              </button>

              <button
                className="actions__btn actions__btn--primary"
                type="submit"
              >
                {translation.button}
              </button>
            </div>
          </div>
        </form>
      )
    }

    return null;
  }
})

export default translate('Activate')(Activate);



// WEBPACK FOOTER //
// ./src/app/components/Register/Activate.js